import {LOAD_WORK_ORDER_SUCCESS} from "../actions/dispatchTypes";

export default function clientDamageRulesReducer(state = null, action) {
    switch (action.type) {
        case LOAD_WORK_ORDER_SUCCESS:
            return action.payload.damageRules || state;
        default:
            return state;
    }
}